import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import RotaDuty from "./duty";
import RotaList from "./RotaList";
import Navigation from "../../partials/navigation";
import RotaDetails from "./partials/RotaDetails";
import Footer from "../../partials/footer";

class Index extends Component {
    render() {
        return (
            <>
                <div className="page-wrapper">
                    {/* Very top navigation */}
                    <Navigation history={this.props.history} />
                    <div className="page-container">
                        <div className="page-content-wrapper page-content-wrapper-home">
                            <div className="page-content page-content-home">
                                <Switch>
                                    <Route exact path="/home/rota" component={RotaDuty} />
                                    <Route path="/home/rota/rotalist" component={RotaList} />
                                    <Route path="/home/rota/viewrota" component={RotaDetails} />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default Index;
